import { useCallback, useState } from 'react';
import { FilterState } from '../types';
import { INITIAL_FILTER_STATE } from '../constants';

export const useMapFilters = (initialFilters?: Partial<FilterState>) => {
    const [filters, setFilters] = useState<FilterState>({
        ...INITIAL_FILTER_STATE,
        ...initialFilters,
    });

    const updateFilter = useCallback((key: keyof FilterState, value: string | boolean | number[]) => {
        setFilters((prev) => ({ ...prev, [key]: value }));
    }, []);

    const updateFilters = useCallback((newFilters: Partial<FilterState>) => {
        setFilters((prev) => ({ ...prev, ...newFilters }));
    }, []);

    const clearFilters = useCallback(() => {
        setFilters(INITIAL_FILTER_STATE);
    }, []);

    return {
        filters,
        updateFilter,
        updateFilters,
        clearFilters,
        setFilters,
    };
};
